import { OrderHistoryResponse } from '../../shared/models/OrderHistory';
import emptySliceApi from '../../shared/store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrderHistoryList: builder.query<
      OrderHistoryResponse[],
      { accountId: string }
    >({
      query: ({ accountId }) => `/orders/accounts/${accountId}`,
    }),
  }),
});

export const { useGetOrderHistoryListQuery } = apiSlice;
